module.exports = __webpack_public_path__ + "img/client-1.6c34cff2.jpg";